import React, { useState, useEffect } from 'react';
import UserServices from '../services/UserServices';
import useAsync from '../hooks/useAsync';

function Contect() {
  const { data, error, isLoading } = useAsync(UserServices.getHolidayDetail);

  console.warn(data.data);

  const [isNewHoliday, setIsNewHoliday] = useState(false);

  const [formValues, setFormValues] = useState({
    name: '',
    date: '',
    description: '',
    status: 'show'
  });

  useEffect(() => {
    if (data) {
      if (data.data) {
        // Data exists - we'll update
        setIsNewHoliday(false);
        const dateValue = data.data.date ? data.data.date.split('T')[0] : '';
        setFormValues({
          name: data.data.name || '',
          date: dateValue,
          description: data.data.description || '',
          status: data.data.status || 'show'
        });
      } else {
        // No data exists - we'll create new
        setIsNewHoliday(true);
        setFormValues({
          name: '',
          date: '',
          description: '',
          status: 'show'
        });
      }
    }
  }, [data]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (isNewHoliday) {
        // Create new holiday
        await UserServices.createHolidayDetail(formValues);
        alert('Holiday created successfully');
      } else {
        // Update existing holiday
        await UserServices.updateHolidayDetail(data.data._id, formValues);
        alert('Holiday updated successfully');
      }
      // You might want to refresh the data here
    } catch (error) {
      console.error('Failed to process Holiday details', error);
      alert(`Failed to ${isNewHoliday ? 'create' : 'update'} Holiday details`);
    }
  };

  if (isLoading) {
    return <div className="loader design_loading">Loading...</div>;
  }

  if (error) {
    return <div>Error loading Holiday details</div>;
  }

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
        <div className="my-auto">
          <h5 className="page-title fs-21 mb-1">Holiday</h5>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Holiday
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container-box">
        <div className="container-box-inner table-reponsive-tabe">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-6">
                  <div className="input-field">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      maxLength={10}
                      className="form-control"
                      value={formValues.name}
                      onChange={handleInputChange}
           
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="input-field">
                    <label>Date</label>
                    <input
                      type="date"
                      name="date"
                      className="form-control"
                      value={formValues.date}
                      onChange={handleInputChange}
                  
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="input-field">
                    <label>Description</label>
                    <input
                      type="text"
                      name="description"
                      className="form-control"
                      value={formValues.description}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="input-field">
                    <label>Status</label>
                    <select
                      name="status"
                      className="form-control"
                      value={formValues.status}
                      onChange={handleInputChange}
                    >
                      <option value="show">Show</option>
                      <option value="hide">Hide</option>
                    </select>
                  </div>
                </div>
              </div>
              <button type="submit" className="submit-green-btn">
                {isNewHoliday ? 'CREATE' : 'UPDATE'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contect;